var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"the-header",attrs:{"id":"js-the-header"}},[_c('navigation-contacts',{attrs:{"contacts":_vm.contacts}}),_vm._v(" "),_c('navigation-main',{attrs:{"navigation":_vm.navigation}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aaeff39","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheHeader.vue
// module id = null
// module chunks = 